import { createSelector } from 'reselect';

const list = state => state.contracts.inbox.list;
const inbox = state => state.contracts.inbox;

// CONTRACTS INBOX
export const fetchingSelector = createSelector(inbox, i => i.fetching);
export const fetchedSelector = createSelector(inbox, i => i.fetched);
export const shouldFetchSelector = createSelector(
    fetchingSelector,
    fetchedSelector,
    (fetching, fetched) => !fetching && !fetched
);
export const listSelector = createSelector(list, l => l);

export const paginationSelector = createSelector(inbox, i => ({
    page: i.page,
    totalPages: i.totalPages,
    pageSize: i.pageSize
}));



// WEBPACK FOOTER //
// ./src/selectors/contracts/inbox.js